import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { ThemeProvider } from "./theme/ThemeProvider";
import Header from "./components/Header.jsx";
import Skills from "./components/Skills.jsx";
import Projects from "./components/Projects.jsx";
import Footer from "./components/Footer.jsx";
import ScrollProgress from "./components/ScrollProgress";
import ContactButton from "./components/ContactButtonEmailJS";
import SEOHead from "./components/SEOHead";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text.primary};
    font-family: 'Source Sans Pro', Helvetica, sans-serif;
    transition: all ${({ theme }) => theme.animation.transition};
  }

  * {
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }
  }

  @media (max-width: 480px) {
    html {
      font-size: 12px;
    }
  }

  /* Smooth scrolling for the whole page */
  html {
    scroll-behavior: smooth;
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

function App() {
  return (
    <ThemeProvider>
      <SEOHead />
      <GlobalStyle />
      <ScrollProgress />
      <AppContainer>
        <Header />
        <MainContent>
          <Skills />
          <Projects />
        </MainContent>
        <Footer />
      </AppContainer>
      <ContactButton />
    </ThemeProvider>
  );
}

export default App;
